import { Component, ChangeDetectionStrategy, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { URLService } from "../../../services";
import { QueryParameters } from "../../enums/query.enums";
import { SubscriptionPlan } from "@kells/interfaces/patient";

@Component({
  selector: "kpr-payment-success-modal",
  templateUrl: "./payment-success-modal.component.html",
  styleUrls: ["./payment-success-modal.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaymentSuccessModalComponent {
  constructor(
    private readonly dialog: MatDialog,
    private readonly urlService: URLService,
    @Inject(MAT_DIALOG_DATA) public data: { paymentPlan: SubscriptionPlan }
  ) {}

  get paymentPlan(): string {
    return this.data.paymentPlan ?? SubscriptionPlan.Premium;
  }

  public get isCompletePlan(): boolean {
    return this.paymentPlan === SubscriptionPlan.Complete;
  }

  public goToDashboard(): void {
    this.urlService.removeQueryParam([
      QueryParameters.Payment,
      QueryParameters.PaymentPlan,
    ]);
    this.dialog.closeAll();
  }
}
